<template>
  <div class="main-item-wrapper d-flex flex-column cursor-pointer">
    <div class="item_img" @click="goTo(link)">
      <img v-bind:src="image" @error="imageLoadError($event)" />
      <div class="latest-tag" v-if="latestTag">
        <span class="latest-text">NEW</span>
      </div>
    </div>
    <p class="main-title text-left mb-1" v-if="title" :title="title">
      {{ truncateString(title, 70) }}
    </p>

    <div class="overlay">
      <div
        class="card"
        :style="{
          backgroundImage: 'url(' + imageFeature + ')',
        }"
      >
        <div class="overlayDiv" @click="goTo(link)">
          <div class="titleOverlay">{{ title }}</div>
          <div class="descriptionOverlay">
            {{ description ? truncateString(description, 110) : "" }}
          </div>

          <div class="play-button"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import noimage from "../../../assets/noimage.png";
import IconPlay from "../../../assets/icon/icon-play.svg";
export default {
  name: "card-comp",
  props: [
    "image",
    "imageFeature",
    "latestTag",
    "title",
    "description",
    "link",
    "category",
  ],
  data: function() {
    return {
      mobile: false,
      window: {
        width: 0,
      },
    };
  },
  methods: {
    imageLoadError(event) {
      event.target.src = noimage;
    },
    goTo(link) {
      this.$router.push(link);
    },

    truncateString(str, num) {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    },
    handleResizeforCard() {
      this.window.width = window.innerWidth;

      if (this.window.width >= 992) {
        this.mobile = false;
      } else {
        this.mobile = true;
      }
    },
  },
  created() {
    window.addEventListener("resize", this.handleResizeforCard);
    this.handleResizeforCard();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResizeforCard);
  },
};
</script>

<style scoped>
.item_img {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  padding-top: calc(215 / 382 * 100%);
  z-index: 1;
}
.item_img img {
  background: 100%;
  width: 100%;
  height: auto;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
}

.item_img_hovered {
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  padding-top: 56.25%;
  z-index: 1;
}
.item_img_hovered img {
  background: 100%;
  width: 100%;
  height: auto;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
}
.main-item-wrapper .overlay {
  display: none;
}

.latest-tag {
  position: absolute;
  top: 6px;
  right: 6px;
  padding: 3px 5px;
  background: #fab92b;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.latest-text {
  font-weight: bold;
  font-size: 10px;
  line-height: 1.14;
  text-align: left;
  color: #000000;
  font-family: "Poppins", sans-serif !important;
}
.main-title {
  font-family: "Poppins", sans-serif !important;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  margin-top: 8px;
}
.category-title {
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  color: #fab900;
}
.long-title {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.17;
  color: #ffffff;
}
.custom-btn {
  background: #fab92b;
  border: none;
  border-radius: 4px;
  color: #000000;
  font-size: 10px;
  line-height: 16px;
  padding: 2px 6px;
  max-width: 105px;
}
.btn-icon {
  width: 10px !important;
}
.main-item-wrapper {
  z-index: 1;
}
@media only screen and (min-width: 992px) {
  .main-item-wrapper:hover {
    transition: 0.2s all ease-in-out;
    transform: translateY(2%) translateX(-2%) scale(1.15);
    z-index: 2000;
    background: #423c3c;
    max-width: 110%;
    max-height: 110%;
    border-radius: 8px;
    z-index: 1111;
    position: relative;
  }
  .main-item-wrapper:hover .item_img {
    display: none;
  }

  .main-item-wrapper:hover .main-title {
    display: none;
  }
  .main-item-wrapper:hover .overlay {
    display: block;
  }

  /* newly added */
  .card {
    position: relative;
    width: 100%;
    overflow: hidden;
    position: relative;
    padding-top: calc(290 / 517 * 100%);
    border-radius: 8px;
    overflow: hidden;
    color: white;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border: 0;
  }

  .overlayDiv {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to top,
      rgba(62, 28, 150, 1),
      rgba(62, 28, 150, 0.3)
    );
    padding: 8px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .titleOverlay {
    font-size: 14px;
    line-height: 18px;
    font-weight: bold;
    color: #ffd700;
    text-align: left;
    font-family: "Poppins", sans-serif !important;
  }

  .descriptionOverlay {
    font-family: "Poppins", sans-serif !important;
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    color: white;
    margin-top: 4px;
    margin-bottom: 8px;
    text-align: left;
  }

  .play-button {
    width: 20px;
    height: 20px;
    background-color: #ffd700;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .play-button::before {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-left: 10px solid black;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    margin-left: 2px;
  }
}
@media only screen and (max-width: 992px) {
  .custom-btn {
    max-width: 150px;
    font-size: 10px;
    padding: 4px 8px;
    height: 32px;
  }
  .btn-icon {
    width: 10px !important;
  }
}
@media only screen and (max-width: 480px) {
  .custom-btn {
    max-width: 100px;
    font-size: 10px;
    padding: 4px 0;
    height: 24px;
  }
  .btn-icon {
    width: 10px !important;
  }
}
</style>
<style>
@media only screen and (max-width: 480px) {
  .main-title {
    font-size: 12px;
  }
}
</style>
